import { render, staticRenderFns } from "./AlphabetList.vue?vue&type=template&id=e0558df4&scoped=true&"
import script from "./AlphabetList.vue?vue&type=script&lang=ts&"
export * from "./AlphabetList.vue?vue&type=script&lang=ts&"
import style0 from "./AlphabetList.vue?vue&type=style&index=0&id=e0558df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0558df4",
  null
  
)

export default component.exports